import React from "react";
import {Field} from "redux-form";
import {Labeled} from "admin-on-rest";
import {required} from "admin-on-rest";

const isRequired = validate => {
  if (validate === required) return true;
  if (Array.isArray(validate)) {
    return validate.includes(required);
  }
  return false;
};

const EmbeddedArrayInputFormField = ({input, prefix, ...rest}) => {
  const name = input.props.source ? `${prefix}.${input.props.source}` : prefix;
  const source = name;

  if (input.props.addField) {
    if (input.props.addLabel) {
      return (
        <Field
          {...rest}
          {...input.props}
          name={name}
          source={source}
          component={Labeled}
          isRequired={isRequired(input.props.validate)}
        >
          {input}
        </Field>
      );
    }
    return (
      <Field
        {...rest}
        {...input.props}
        name={name}
        source={source}
        component={input.type}
        isRequired={isRequired(input.props.validate)}
      />
    );
  }
  if (input.props.addLabel) {
    return (
      <Labeled
        {...rest}
        source={source}
        isRequired={isRequired(input.props.validate)}
      >
        {input}
      </Labeled>
    );
  }
  return typeof input.type === "string"
    ? input
    : React.cloneElement(input, {
        ...rest,
        source: name
      });
};

export default EmbeddedArrayInputFormField;



// WEBPACK FOOTER //
// ./src/components/CRM/EmbeddedArrayInputFormField.js